import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getActiveCardToken = createSelector(creditCardsState, (creditCards) => creditCards.activeCardToken);
